import { render, staticRenderFns } from "./model-detailsOfTheCompany.vue?vue&type=template&id=1c404fb0&scoped=true&"
import script from "./model-detailsOfTheCompany.vue?vue&type=script&lang=js&"
export * from "./model-detailsOfTheCompany.vue?vue&type=script&lang=js&"
import style0 from "./model-detailsOfTheCompany.vue?vue&type=style&index=0&id=1c404fb0&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c404fb0",
  null
  
)

export default component.exports